const URL = '/tickets';

const state = {
  all: [],
  edited: {
    id: null,
    fecha: null,
    cantidad: null,
    cliente: null,
    cuenta: null,
    cuenta_id: null,
    producto_id: null,
    chofer_id: null,
    created_at: null,
    updated_at: null,
  },
  selected: {
    id: null,
    fecha: null,
    cantidad: null,
    cliente: null,
    cuenta: null,
    cuenta_id: null,
    producto_id: null,
    chofer_id: null,
    created_at: null,
    updated_at: null,
  },
  filters: {
    fecha_from: null,
    fecha_to: null,
    cuenta_id: null,
    producto_id: null,
    chofer_id: null,
  },
  loading: false,
  headers: [
    {
      text: 'Fecha',
      value: 'fecha',
      align: 'center'
    },
    // {
    //   text: 'Chofer',
    //   value: 'chofer_id',
    //   align: 'center'
    // },
    {
      text: 'Cliente',
      value: 'cliente',
      align: 'center'
    },
    {
      text: 'Cuenta',
      value: 'cuenta',
      align: 'center'
    },
    {
      text: 'Cantidad',
      value: 'cantidad',
      align: 'center'
    },
    {
      text: 'Producto',
      value: 'producto_id',
      align: 'center'
    },
  ],
  options: {
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  edited (state) {
    return state.edited
  },
  filters (state) {
    return state.filters
  },
  headers (state) {
    return state.headers
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearAll ({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      itemsPerPage: 10,
      page: 1,
      sortBy: [],
      sortDesc: []
    })
    commit('setItemsLength', null)
  },
  onClearEdited ({ commit}) {
    commit('setEdited', {
      id: null,
      fecha: null,
      cantidad: null,
      cliente: null,
      cuenta: null,
      cuenta_id: null,
      producto_id: null,
      chofer_id: null,
      created_at: null,
      updated_at: null,
    })
  },
  onClearSelected ({ commit}) {
    commit('setSelected', {
      id: null,
      fecha: null,
      cantidad: null,
      cliente: null,
      cuenta: null,
      cuenta_id: null,
      producto_id: null,
      chofer_id: null,
      created_at: null,
      updated_at: null,
    })
  },
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          fecha_from: state.filters.fecha_from,
          fecha_to: state.filters.fecha_to,
          cuenta_id: state.filters.cuenta_id,
          producto_id: state.filters.producto_id,
          chofer_id: state.filters.chofer_id,
        }
      })
        .then(response => {
          commit('setAll', response.data.data)
          commit('setItemsLength', response.data.meta.total)
          if (state.options.page + state.options.itemsPerPage > response.data.meta.total)
            commit('setPage', 1)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setEdited (state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
